export const URLS = {

    // Live
    baseApi: 'https://api.bad-kursmanager.de/apiv2/student/',

    // Staging
    // baseApi: 'https://api.akademio-digital.de/apiv2/student/',

    // Local
    // baseApi: 'http://192.168.31.248:3000/apiv2/student/',

}